import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=60d5d7c3&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"
import style0 from "./Car.vue?vue&type=style&index=0&id=60d5d7c3&prod&lang=css"
import style1 from "./Car.vue?vue&type=style&index=1&id=60d5d7c3&prod&lang=scss&scoped=true"
import style2 from "./Car.vue?vue&type=style&index=2&id=60d5d7c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5d7c3",
  null
  
)

export default component.exports